import { FC } from 'react'

type ILoadingIndicator = {
  message?: string
}
export const LoadingIndicator: FC<ILoadingIndicator> = ({ message = 'Aguarde...' }) => {
  return (
    <span className='indicator-progress' style={{ display: 'block' }}>
      {message} <span className='spinner-border spinner-border-sm align-middle ms-2' />
    </span>
  )
}
